import { Serializer } from '@lib/store';
import { servicingSeatmapBackupInitialState } from './servicing-seatmap-backup.reducer';
import { ServicingSeatmapBackupState } from './servicing-seatmap-backup.state';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const servicingSeatmapBackupStorageDeserializer = (rawObject: any) => {
  return {
    ...servicingSeatmapBackupInitialState,
    model: rawObject && rawObject.model ? rawObject.model : null,
  } as ServicingSeatmapBackupState;
};

export const servicingSeatmapBackupStorageSync: Serializer<ServicingSeatmapBackupState> = {
  deserialize: servicingSeatmapBackupStorageDeserializer,
};